import api from 'base/utils/api';
import { IAddress, ICity, ICountryOrState, IUserAddressRulesData } from 'base/interfaces/address';

export function getAddressList(): Promise<IAddress[]> {
    return api.post('/web/userAddress/get');
}

export function addAddress(data: IAddress) {
    return api.post('/web/userAddress/add', { data });
}

export function updateAddress(data: IAddress) {
    return api.post('/web/userAddress/update', { data });
}

export function deleteAddress(id: number) {
    return api.post(`/web/userAddress/delete/${id}`);
}

//获取所有的国家和省份
export function getCountryAndState(): Promise<ICountryOrState[]> {
    return api.get('/web/locale/getALLCountryList');
}

export function getCityByState(params: { stateId: string | number}): Promise<ICity[]> {
    return api.get('/web/locale/getCityByState', {
        params
    });
}

export function getUserAddressRules(params?: {
    countryId?: string | number;
}): Promise<IUserAddressRulesData> {
    return api.get('/web/userAddress/address/rules', {
        params: params || {}
    });
}


